import React, { useEffect, useRef, useState } from 'react'
import ReviewCard from '../../../components/Cards/ReviewCard'
import ClientReviewCard from './ClientReviewCard'
import SatisfiedClientsSectionImage from '../../../assets/imgs/satisfied-clients-section-image.svg'
import { getAllData, getDataById } from '../../../apis/generalApis'
import ChevronRightIcon from '../../../assets/imgs/profile-screen-images/chevron.png'
import ChevronLeftIcon from '../../../assets/imgs/profile-screen-images/chevron-right-profile.png'

const ClientsReviewsSection = () => {
  useEffect(() => {
    getStylistsReviewsForClients()
  }, [])

  const [stylistsReviewsForClients, setStylistsReviewsForClients] = useState([])

  const getStylistsReviewsForClients = async () => {
    let body = {
      user_id: 1,
    }
    let result = await getAllData('show-top-reviews')
    if (result?.data != null && result?.success === true) {
      setStylistsReviewsForClients(result?.data)
    }
  }

  const reviewsSection = useRef()

  const scrollReviews = (scrollValue) => {
    reviewsSection.current.scrollLeft += scrollValue
  }

  return (
    <div className="clients-reviews-section">
      <div className="container py-5">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-4">
            <h1 className="satisfied-clients-heading text-black">Satisfied Clients</h1>
            <div>
              <img src={SatisfiedClientsSectionImage} alt="" height={413} />
            </div>
          </div>
          <div className="position-relative col-12 col-sm-12 col-md-8 d-flex align-items-center">
            <img
              src={ChevronRightIcon}
              alt="Services Slider Icon"
              onClick={() => scrollReviews(500)}
              className="service-slider-icon pointer"
            />
            <img
              src={ChevronLeftIcon}
              alt="Services Slider Icon"
              onClick={() => scrollReviews(-500)}
              className="service-slider-icon pointer left"
            />
            <div
              className="row flex-nowrap overflow-auto m-0 mt-5 pb-2 position-relative mt-4"
              ref={reviewsSection}
              style={{ overflow: 'auto', scrollBehavior: 'smooth' }}
            >
              {stylistsReviewsForClients &&
                stylistsReviewsForClients?.length > 1 &&
                stylistsReviewsForClients?.map((item, index) => (
                  <div
                    className="col-8 col-sm-5 col-md-8 col-lg-5"
                    key={item?.id}
                  >
                    <ReviewCard review={item} />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientsReviewsSection
